import api from "../../../services/api";

/* ================= GET CHECKLIST ================= */

export const getChecklist = (taskId) =>
  api.get(`/work-checklist/by-task/${taskId}`);

/* ================= CREATE ITEM ================= */

export const createChecklistItem = (data) =>
  api.post("/work-checklist", data);

/* ================= UPDATE ITEM ================= */

export const updateChecklistItem = (id, data) =>
  api.put(`/work-checklist/${id}/status`, data);